import React from 'react';
import styled from 'styled-components';

function SubHeader({children, options, center = false, ...props}) {
  if (options && !Array.isArray(options)) {
    options = [options];
  }

  return (
    <Container {...props}>
      <H2 center={center}>{children}</H2>
      {options && (
        <>
          {options.map((option, i) => (
            <Option key={i}>{option}</Option>
          ))}
        </>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  min-height: 2.5rem;
`;

const H2 = styled.h2`
  font-weight: 300;
  font-size: 2rem;
  margin: 0;
  padding: 0;
  flex: 1;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;

  ${props => {
    if (props.center) {
      return `text-align: center;`;
    }
  }}
`;

const Option = styled.div`
  margin-left: 1rem;
`;

export default styled(SubHeader)``;